// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__yn8l-","errorLogs":"EditorFooter_errorLogs__3IkMu"};